






































































import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import Signature from "../../../components/Signature/index.vue";
// const FileSaver = require('file-saver')
import * as FileSaver from "file-saver";

@Component({
  name: "THAttachmentWidget",
  components: { Signature }
})
export default class InputWidget extends WidgetBase {
  private dialogSignVisible: boolean = false;
  private docList: any = []; // 套红附件文件信息list
  private currentDoc: any = null; // 最新的套红附件文件信息
  mounted() {
    this.initValue();
  }
  initValue() {
    const { value } = this;
    try {
      const fileList = JSON.parse(value);
      this.docList = fileList;
      this.currentDoc = fileList[fileList.length - 1];
    } catch (e) {
      this.currentDoc = null;
    }
  }
  onSign(record: any) {
    this.currentDoc.signInfos = record;
    this.value = JSON.stringify(this.docList);
    this.dialogSignVisible = false;
  }
  downloadFile() {
    const {
      currentDoc: { pdfAtt }
    } = this;
    FileSaver.saveAs(pdfAtt.requestRelativeUri, "套红附件.pdf");
  }
  openWindow(url: string) {
    window.open(url);
  }
}
